import type { ReactNode } from 'react'

export function Card({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <div className={`rounded-lg border border-oxblood/10 bg-white/70 ${className}`}>{children}</div>
  )
}

export function StatCard({
  label, value, sub,
}: { label: string; value: ReactNode; sub?: ReactNode }) {
  return (
    <Card className="p-5">
      <p className="font-body text-xs uppercase tracking-[0.15em] text-oxblood/60">{label}</p>
      <p className="mt-2 font-display text-3xl text-oxblood tabular-nums">{value}</p>
      {sub && <p className="mt-1 font-body text-xs text-ink/50">{sub}</p>}
    </Card>
  )
}

export function SectionTitle({ children, note }: { children: ReactNode; note?: string }) {
  return (
    <div className="mb-3 flex items-baseline justify-between">
      <h2 className="font-display text-2xl text-oxblood">{children}</h2>
      {note && <span className="font-body text-xs text-ink/40">{note}</span>}
    </div>
  )
}

export function EmptyState({ title, hint }: { title: string; hint?: ReactNode }) {
  return (
    <div className="rounded-lg border border-dashed border-oxblood/20 bg-blush/20 px-6 py-12 text-center">
      <p className="font-display text-lg text-oxblood/80">{title}</p>
      {hint && <p className="mx-auto mt-2 max-w-md font-body text-sm text-ink/50">{hint}</p>}
    </div>
  )
}

const TIER_STYLE: Record<string, string> = {
  budget: 'bg-blue-50 text-blue-700 border-blue-200',
  mid: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  premium: 'bg-violet-50 text-violet-700 border-violet-200',
  bespoke: 'bg-oxblood/10 text-oxblood border-oxblood/20',
}
export function TierBadge({ tier }: { tier: string | null }) {
  if (!tier) return <span className="text-ink/30">—</span>
  return (
    <span className={`inline-block rounded-full border px-2 py-0.5 font-body text-[11px] capitalize ${TIER_STYLE[tier] ?? 'bg-gray-50 text-gray-600 border-gray-200'}`}>
      {tier}
    </span>
  )
}

// The estimated-weight flag — never let estimated data pass as published.
export function EstFlag({ show }: { show: boolean }) {
  if (!show) return null
  return (
    <span
      title="Weight estimated from ring geometry, not published by the competitor"
      className="ml-1 inline-block rounded border border-gold/50 bg-gold/15 px-1 py-px font-body text-[10px] font-semibold uppercase text-oxblood/70"
    >
      est
    </span>
  )
}
